module.exports = __webpack_public_path__ + "static/media/reallyhappy200h.9751de47.png";